module.exports = __webpack_public_path__ + "img/edit_b.7e1e415f.svg";